// removed by extract-text-webpack-plugin
module.exports = {"button":"_19Z2HngI730dIrCDutMat4","button__icon":"_74i18HPQB-ocksLNY7f1S"};